import { validateOptionsList } from '../../../../utils';
import { RadioButtonsInputDefinition } from '../../../../types';

// radio buttons input validation
export default (input: RadioButtonsInputDefinition, errors: string[]) => {
  const { options } = input;
  validateOptionsList(errors, options);
};
